export default __webpack_public_path__ + "static/media/kaapi-6.46859608.jpg";